import { useMutation } from '@tanstack/react-query';
import { downloadHmsReportPdf, HmsReportPdf } from '../../api/workEnvironmentQueries';
import { DownloadBlobFileUtils } from '../../utils/DownloadBlobFileUtils';
import { useSurveyPaths } from '../useSurveyPaths';

const FILENAMES: Record<HmsReportPdf, string> = {
  'work-environment-report': 'arbeidsmiljorapport',
  'work-environment-inspection-report': 'tilsynsrapport',
};

/** Downloads the report as a PDF made by the backend, for the part of the app the user is in */
export const useHmsReportPdfMutation = (key: HmsReportPdf, surveyId: number) => {
  const { section } = useSurveyPaths();
  return useMutation({
    mutationFn: () => downloadHmsReportPdf(key, surveyId, section),
    onSuccess: (blob) =>
      DownloadBlobFileUtils.downloadBlob(blob, DownloadBlobFileUtils.generateFilenameWithDate(FILENAMES[key], 'pdf')),
  });
};
